import { h } from 'preact';
import { useState, useContext } from 'preact/hooks';
import Prismic from '@prismicio/client';

// COOKIE-REVIEW: Prismic CMS integration. The @prismicio/client may set cookies for:
// 1. Preview mode tracking (io.prismic.preview)
// 2. A/B testing experiments (io.prismic.experiment)
// 3. Session management for content editors
// These cookies are set by Prismic's CDN/API on their domain, not directly by this code.
// To disable: Remove Prismic integration or configure client to disable preview/experiment features.
// Impact: Loss of content preview capabilities and A/B testing for editors.

// Prismic API
const apiEndpoint = 'https://aflaccyberprotection.prismic.io/api/v2';
const Client = Prismic.client(apiEndpoint);

// COOKIE-REVIEW: Prismic may set preview / experiment cookies (e.g., io.prismic.preview, experiment cookies)
// when using preview sessions or A/B testing. This file only creates a client; no direct document.cookie usage here.
// If removing such cookies: disable preview feature or avoid loading Prismic preview scripts.

const prismicClient = async (type, page) => {
   const client = await Client.getByUID( type, page );
//    console.log('prismicClient: ', client);
   return client;
};
const prismicBlogs = async (type) => (
    await Client.query(
        Prismic.Predicates.at('document.type', type),
        { pageSize: 8, page: 1, orderings: '[my.blog_post.post_date]' }
    )
);
export { prismicClient, prismicBlogs };
// primsmic api end
